export enum RotaEnum {

  Inicio = '',
  Home = 'home',
  Empresa = 'empresas',
  IdentificacaoPreenchimento = 'responsavel-rda',
  Instituicao = 'instituicoes',
  DeclaracaoRda = 'declaracao-rda',
  ValidaRda = 'valida-rda',
  FaturamentoBruto = 'faturamento-bruto',
  Projeto = 'projetos',
  FaturamentoProduto = 'produtos',
  DispendioEquipamentoSoftware = 'dispendio-equipamento-software',
  DispendioOutro = 'dispendio-outro',
  DispendioRecursoHumano = 'dispendio-recurso-humano',
  AnexoDocumentoRda = 'anexo-documento-rda',
  ObrigacaoAplicacao = 'rda/obrigacao-aplicacao',
  ConsolidarObrigacaoAplicacao = 'consolidar',
  CadastrarObrigacaoRepassada = 'repassar',
  VisualizarObrigacaoRepassada = 'visualizar-repassada',
  ConsultarObrigacaoAssumida = 'assumir',
  VisualizarObrigacaoAssumida = 'visualizar-assumida',
  RelatorioConclusivo = 'relatorio-conclusivo',
  ConfiguracaoParametro = 'configuracoes',
  GerarCartaCredito = 'carta-credito',
  GerirEntidade = 'entidades',
  GerirStatus = 'status',
  TermosCarta = 'termo-carta-credito',
  TermosRetificacaoCarta = 'termo-retificacao-carta-credito',
  GerirPleito = 'pleitos',
  GerirPleitoMCTI = 'pleitos/mcti',
  GerirProduto = 'pleitos/:idPleito/produtos',
  Rda = 'rda',
  VincularContratante = 'vincular-contratante',
  RetificarCartaCredito = 'retificar-carta-credito',
  FiscalizacaoElaborarParecer = 'elaborar-parecer',
}
